import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_DASHBOARD_SEND_TASKS } from './actionTypes';
import { getDashboardSendTasksSuccess, getDashboardSendTasksError } from './actions';
import { taskStatusBack } from '../../../constants/task_fields';

// Include call API
import { getTasksAPI } from '../../../api/tasks';

const tasksAPI = getTasksAPI();

const SEND_STATUS = [
  taskStatusBack.PENDIENTE_RETORNO,
  taskStatusBack.PENDIENTE_CONTINUE,
  taskStatusBack.QUEUE_IN,
  taskStatusBack.EJECUTANDO,
  taskStatusBack.ENVIADA,
].join(',');

function* getDashboardSendTasks({ payload: { user, size, page } }) {
  try {
    const response = yield call(tasksAPI.getTasks, user.token, size, page, SEND_STATUS);
    yield put(getDashboardSendTasksSuccess(response.paginator, response.message));
  } catch (error) {
    yield put(getDashboardSendTasksError(error));
  }
}

export function* watchGetDashboardSendTasks() {
  yield takeEvery(GET_DASHBOARD_SEND_TASKS, getDashboardSendTasks);
}

function* getDashboardSendTasksSaga() {
  yield all([fork(watchGetDashboardSendTasks)]);
}

export default getDashboardSendTasksSaga;
